import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../core/modules/common/components/Modal';

const LegendModal = (props) => {
  const {
    closeChart,
  } = props;

  return (
    <div className="chart-modal">
      <Modal
        closeOnOutsideClick
        onClose={closeChart}
      >
        <div className="chart-modal__wrapper" style={{ position: 'relative', height: '200px' }}>
          <div style={{ float: 'left' }}>
            <table>
              <tbody>
                <tr style={{ backgroundColor: '#00AF4F' }}>
                  <td style={{ color: '#FFFFFF', borderRight: '1px solid rgba(0, 0, 0, 0.1)' }}>97.0% - 100.0%</td>
                </tr>
                <tr>
                  <td style={{ backgroundColor: '#FFC000' }}>95.0% - 96.9%</td>
                </tr>
                <tr>
                  <td style={{ color: '#FFFFFF', backgroundColor: '#FF0000' }}>0.0% - 94.9%</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style={{ marginLeft: '100px' }}>
            <table>
              <tbody>
                <tr>
                  {/* eslint-disable-next-line react/no-unescaped-entities */}
                  <p><span style={{ textDecoration: 'underline' }}>Source: </span>Operators' data from CAPE Vision.</p>
                </tr>
                <tr>
                  <p><span style={{ textDecoration: 'underline' }}>Legend: </span>Based on the number of receptacles with RESDES scanned by the inbound Operators versus the number of receptacles with PREDES sent by the outbound Operators</p>
                </tr>
                <tr>
                  <p>The EPG RESDES scanning performance report is sent to the EPG Project Managers (PMT) on a monthly basis. Operators can check their link-by-link performance via the dedicated report in CAPE Vision.</p>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Modal>
    </div>
  );
};


LegendModal.propTypes = {
  closeChart: PropTypes.func.isRequired,
};

export default LegendModal;
